<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
  <div nz-row nzGutter="12">
    <nz-divider nzText="Trình độ" nzOrientation="left" nzPlain ></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chuyên môn</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chuẩn chuyên môn</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chuyên ngành khác</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Trình độ vi tính</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chứng chỉ vi tính</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Trình độ khác</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <nz-divider></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Điểm ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Trình độ Đ,tạo ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Nhóm Chứng chỉ ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chứng chi ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Khung năng lực ngoại ngữ</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <nz-divider></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">G.viên có C.chỉ tiếng D.tộc T.số</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Cơ sở đào tạo</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tham gia BD nghiệp vụ QLGD</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tham gia BD nghiệp vụ QLGD</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Tham gia BD thay sách</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <nz-divider></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Học hàm</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Học vị</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
    </div>
    <nz-divider></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chính trị</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">QL nhà nước</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">QL giáo dục</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Chủ nhiệm khối</nz-form-label>
        <nz-form-control nzSpan="24">
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Chọn">
            <nz-option nzValue="1" nzLabel="Kinh"></nz-option>
            <nz-option nzValue="2" nzLabel="Ê-Đê"></nz-option>
            <nz-option nzValue="3" nzLabel="Hoa"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <label nz-checkbox>Ứng dụng CNTT</label>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
    </div>
  </div>
</div>